module.exports = __webpack_public_path__ + "media/elephant_l.944bbbf0.webm";